import { Zap, Store, IndianRupee, HeartHandshake } from "lucide-react";
import { GlassCard, SectionHeading } from "./GlassCard";

const points = [
  {
    icon: Zap,
    title: "Superfast Local Delivery",
    desc: "Samaan door ke warehouse se nahi, balki aapke pados ki dukaano se aata hai, isliye aapka order minto mein seedha aapke darwaze par pahunch jata hai.",
  },
  {
    icon: Store,
    title: "Aapki Jaani-Pehchaani Dukaane",
    desc: "Anjaan sellers nahi, balki apne hi area ke trusted aur favorite dukandaaron se online khareedari karne ka poora vishwas.",
  },
  {
    icon: IndianRupee,
    title: "Sahi Daam, Koi Hidden Fees Nahi",
    desc: "Direct dukaandar se judne par aapko milta hai market ka sabse best price, bina kisi faltu platform charges ya chhupi hui fees ke.",
  },
  {
    icon: HeartHandshake,
    title: "Local Market Ko Support",
    desc: "Gromza se khareed kar aap badi e-commerce companiyon ke bajaye apne aas-paas ke vyapariyon ko aage badhne mein directly madad karte hain.",
  },
];

export const Customers = () => (
  <section id="customers" data-testid="customers-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <SectionHeading
        testId="customers-heading"
        eyebrow="For Customers"
        title="Pados ki dukaan,"
        highlight="ab aapke phone mein."
        description="Gromza se khareedari ka matlab hai — wahi bharosa, wahi daam, aur minto mein delivery. Bina kisi beech ke platform ke."
        align="center"
      />
      <div className="mt-16 grid sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {points.map((p, i) => (
          <GlassCard key={p.title} testId={`customer-card-${i}`} delay={i} className="p-9 group relative overflow-hidden">
            <div className="absolute -top-12 -right-12 w-36 h-36 rounded-full bg-amber-400/10 blur-3xl group-hover:bg-amber-400/25 transition-colors duration-700" />
            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-amber-400/10 border border-amber-400/25 flex items-center justify-center mb-6 group-hover:bg-amber-400/20 group-hover:scale-105 transition-[background-color,transform] duration-400">
                <p.icon size={26} className="text-amber-400" />
              </div>
              <h3 className="font-display text-2xl font-semibold mb-3">{p.title}</h3>
              <p className="text-base text-slate-400 leading-relaxed">{p.desc}</p>
            </div>
          </GlassCard>
        ))}
      </div>
    </div>
  </section>
);
